<!--
 * @Author: wjc
 * @Date: 2025-06-18 09:09:53
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-10 17:27:46
 * @Description: 
-->
<template>
  <TooltipProvider v-bind="props">
    <slot></slot>
  </TooltipProvider>
</template>

<script setup lang="ts">
  import type { TooltipProviderProps } from 'reka-ui'

  import { TooltipProvider } from 'reka-ui'

  const props = defineProps<TooltipProviderProps>()
</script>
